const City = require('../components/city');
const $ = require('jQuery');

module.exports = {
  name: 'panel',
  props: {
    stoptimes: {
      type: Array,
      required: true,
    },
    tempStopData: {
      type: Array,
      required: false,
    },
    stopInfo: {
      type: Array,
      required: false,
    },
    expanded: {
      type: Boolean,
      required: true,
    },
    goldenTrip: {
      type: String,
      required: true,
    }
  },

  data: function() {
    return {
      scrolledX: 0,
    };
  },

  computed: {
    byCity() {
      // groups all stop_times by city and
      // copies info into new objects
      const cityObject = {};

      //CAM
      //const testArray = [];
      // console.log('looking for golden trip ' + this.goldenTrip);
      // console.log('stoptimes');
      // console.log(this.stoptimes);

      this.stoptimes.map(stop => {
        // console.log(stop);
        const cityExists = cityObject.hasOwnProperty(stop.city);
        const [hours, mins, secs] = stop.field_departure_time
          .split(':')
          .map(Number);
        const departureInSeconds = secs + mins * 60 + hours * 3600;
        if (!cityExists) {
          //console.log('city does not exist ' + stop.city);
          cityObject[stop.city] = [];
          cityObject[stop.city].startTime = Infinity;
        }

        // check if this stop is in the right trip
        //console.log('trip id ' + stop.trip_id);
        //console.log('golden trip id ' + this.goldenTrip);

        //for testing CAM
        //testArray.push(stop.trip_id);

        if (stop.trip_id == this.goldenTrip) {
          //console.log('matched trip_id and goldenTrip  ' + stop.trip_id);

        // if ($.inArray(stop.trip_id, this.goldenTrip) > -1) {
          // if it is, check if it's start time is earlier than the stored start time
          if (departureInSeconds < cityObject[stop.city].startTime) {
            // if it is, set the new lower start time
            cityObject[stop.city].startTime = departureInSeconds;
          }
        }else{
          // console.log(stop.trip_id + ' is not golden '+ this.goldenTrip);
        }
        // always add stop_time to city array for grouping
        cityObject[stop.city].push(stop);
      });
      //CAM
      //console.log(testArray);
      return cityObject;
    },

    // generate a sorted list of cities
    citySorted() {
      const sorted = this.objectSorter(this.byCity, 'startTime');
      // console.log('citySorted');
      // console.log(sorted);
      return sorted;
    },
  },

  methods: {
    debugGoldenTrips(){
      var trips = {};
      var count = 0;
      this.stoptimes.map(stop => {
        const tripAdded = trips.hasOwnProperty(stop.trip_id);
        if(tripAdded){
          trips[stop.trip_id] = trips[stop.trip_id] + 1;
        }else{
          trips[stop.trip_id] = 1;
        }
      });
      //console.log(trips);
    },
    onMove(ui) {
      this.scrolledX = ui.position.left;
    },

    // pickupTypeEnglish(pickupType) {
    //   if (pickupType == '0') {
    //     return 'regular';
    //   } else {
    //     return 'request';
    //   }
    // },
    pickupTypeEnglish(stop_alias) {
      //stop_alias = stop_alias.toLowercase();

      if (stop_alias.indexOf("ON CALL") === -1) {
        return 'regular';
      } else {
        return 'request';
      }
    },

    timepointEnglish(timepoint) {
      if (timepoint == '0') {
        return 'approximate';
      } else {
        return 'exact';
      }
    },

    allStops(arr) {
      const stopObject = {};
      //console.log(arr);

      arr.forEach(stop => {
        //console.log(stop);
        const stopExists = stopObject.hasOwnProperty(stop.stop_id);
        if (!stopExists) {
          stopObject[stop.stop_id] = {};
          stopObject[stop.stop_id].alias = stop.stop_alias;
          stopObject[stop.stop_id].id = stop.stop_id;
          stopObject[stop.stop_id].sequence = Infinity;
          //stopObject[stop.stop_id].pickupType = this.pickupTypeEnglish(stop.pickup_type);
          stopObject[stop.stop_id].pickupType = this.pickupTypeEnglish(stop.stop_alias);
          // used for debugging
          // stopObject[stop.stop_id].triggered = stop.stop_id;
          stopObject[stop.stop_id].timepoint = this.timepointEnglish(stop.timepoint);
          // console.log(stop.stop_alias);
        }

        // give the stop the sequence of the correct stoptime from the right trip
        if (stop.trip_id == this.goldenTrip) {
        // if ($.inArray(stop.trip_id, this.goldenTrip) > -1) {
          stopObject[stop.stop_id].sequence = stop.field_stop_sequence;
        }

        // //////////////
        // SPECIAL CASE!
        // //////////////
        // PNSY Gate 1 on route 41. only goes there once, on one trip that skips other stops
        // so there is no true golden trip on route 41 inbound
        if (stop.stop_id == 'stop_ports014' && stop.trip_id == 'trip_41i_0612') {
          // assing highest sequence number (as a string to match other) for this one case
          stopObject[stop.stop_id].sequence = '999';
        }

        // always check pickup, we assume if one stop_time
        // is request only, entire stop is
        if (stopObject[stop.stop_id].pickupType == 'regular' && stop.pickup_type == '2') {
          stopObject[stop.stop_id].pickupType = this.pickupTypeEnglish(stop.pickup_type);
        }

        // always check timepoint, we assume if one stop_time
        // is by approximately timed, entire stop is
        if (stopObject[stop.stop_id].timepoint == 'exact' && stop.pickup_type == '0') {
          stopObject[stop.stop_id].timepoint = this.timepointEnglish(stop.timepoint);
        }
      });
      // logs out list of stops
      // console.log(stopObject);
      return stopObject;
    },

    // parses through all stop times to create a trip object that
    // holds the trip ID, time of first stop time on trip, and the
    // the highest sequence of stoptimes to track last one
    allTrips(arr) {
      const tripObject = {};
      arr.forEach(trip => {
        // console.log(trip);
        const tripExists = tripObject.hasOwnProperty(trip.trip_id);
        const [hours, mins, secs] = trip.field_departure_time
          .split(':')
          .map(Number);
        // calc departure time in seconds
        const departureInSeconds = secs + mins * 60 + hours * 3600;
        // create trip if it doesn't exist
        if (!tripExists) {
          // create object for trip as part of main tripObject
          tripObject[trip.trip_id] = [];
          // assign the trip id
          tripObject[trip.trip_id].id = trip.trip_id;
          // assign the departime of first stop we find on this trip
          tripObject[trip.trip_id].time = departureInSeconds;
          // assign the sequence of first stop we find on this trip
          tripObject[trip.trip_id].highestSequence = parseInt(trip.field_stop_sequence, 10);
        }

        // check if time of stop_time is lower than value stored,
        // if so, update the start time of trip
        if (trip.field_departure_time < tripObject[trip.trip_id].time) {
          tripObject[trip.trip_id].time = departureInSeconds;
        }

        // ///////
        // SPECIAL CASE
        // ///////
        if (trip.trip_id === 'trip_2n_mtwrf_0644') {
          // sets trip start time at 6:00am to sort correctly
          tripObject[trip.trip_id].time = 21600;
        }

        if (trip.trip_id === 'trip_2s_mtwrf_0527') {
          // sets trip start time at 12am to sort correctly
          tripObject[trip.trip_id].time = 0;
        }

        // check if sequence is higher than value stored,
        // if so update the highestSequence
        if (parseInt(trip.field_stop_sequence, 10) > tripObject[trip.trip_id].highestSequence) {
          tripObject[trip.trip_id].highestSequence = parseInt(trip.field_stop_sequence, 10);
        }

      });
      // logs out all trips for calendar/headsign combo with id, earliest start time, and highestSequence
      // console.log('tripObject');
      // console.log(tripObject);
      return tripObject;
    },

    // sorts objects and keeps their key as first item in nested array
    // second parameter is what the object should be sorted by - must be a number for this function
    objectSorter(obj, itemToSortBy) {
      const sortedArray = [];
      //console.log('sorter is looking for key startTime im byCity');

      for (const key in obj) {
        if(!isNaN(parseInt(obj[key][itemToSortBy]))) {
          sortedArray.push([key, parseInt(obj[key][itemToSortBy])]);
        }
      }
      // console.log('paneljs objectSorter sortedArray');
      // console.log(sortedArray);

      sortedArray.sort((a, b) => {
        const seqA = parseInt(a[1]);
        const seqB = parseInt(b[1]);
        if (seqA < seqB) {
          return -1;
        }
        if (seqA > seqB) {
          return 1;
        }
        // sequence must be equal
        return 0;
      });
      // console.log(sortedArray);
      return sortedArray;
    },
  },

  mounted: function() {
    //console.log('paneljs prop stoptimes from dataFiltered tabsjs');
    //console.log(this.stoptimes);
    // console.log('golden trip on mounted ' + this.goldenTrip);
    // logs out golden trip for selected calender/headsign combo
    // console.log(this.goldenTrip);
    //this.debugGoldenTrips();
  },

  updated: function() {
    // logs out golden trip for selected calender/headsign combo
    // console.log(this.goldenTrip);
  },

  render() {
    const allTripsForPanel = this.allTrips(this.stoptimes);

    return (
      <div>
      <span class="move-row-icon icon-arrow-right"></span>
      <transition-group name="list" duration="500" tag="div">
        {this.citySorted.map(city =>
          this.stoptimes.length >= 1 &&
            <div class="schedule__panel" key={city}>
              {
                /* pass in all route data, and all trips for headsign/calendar time,
                  and all stops for this city based on headsign/calendar time */
              }
              <City
                cityName={city[0]}
                routeData={this.stoptimes}
                allStops={this.allStops(this.byCity[city[0]])}
                allTrips={allTripsForPanel}
                tempStopData={this.tempStopData}
                currentCity={city[0]}
                stopInfo={this.stopInfo}
                onDrag={this.onMove}
                scrolledX={this.scrolledX}
                expanded={this.expanded}
              />
            </div>

        )}
        </transition-group>
      </div>
    );
  },
}
